import './ChatLoadingExperience.css';

export default function ChatThreadLoading({ thinking = false }) {
    return (
        <div className='chatThreadInitialLoading' role='status' aria-live='polite'>
            <div className='chatThreadLoadingQuery' aria-hidden='true'>
                <span />
            </div>
            <div className='chatLoadingActivity'>
                <span>{thinking ? 'Thinking…' : 'Loading conversation…'}</span>
            </div>
            <div className='chatThreadLoadingLines' aria-hidden='true'>
                <span />
                <span />
                <span />
            </div>
        </div>
    );
}
